import React from 'react';
import {
  Stack,
  Typography,
  Avatar,
  Tooltip,
  IconButton
} from '@mui/material';
import {
  Close as CloseIcon,
  People as PeopleIcon
} from '@mui/icons-material';

const EmployeeAvatarFilter = ({ employees, selectedEmployee, onEmployeeChange }) => {
  const handleEmployeeClick = (employeeId) => {
    // If clicking the already selected one, deselect (show all)
    if (selectedEmployee === employeeId) {
      onEmployeeChange('all');
    } else {
      onEmployeeChange(employeeId);
    }
  };

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" sx={{ py: 1 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ whiteSpace: 'nowrap', fontWeight: 500, mr: 0.5 }}
      >
        Filtrar:
      </Typography>

      <Stack direction="row" spacing={1} flexWrap="wrap" alignItems="center">
        {/* "Todos" option */}
        <Tooltip title="Todos" arrow>
          <Avatar
            onClick={() => onEmployeeChange('all')}
            sx={{
              width: 32,
              height: 32,
              fontSize: '0.7rem',
              fontWeight: 600,
              cursor: 'pointer',
              border: '2px solid',
              borderColor: selectedEmployee === 'all' ? 'primary.main' : 'transparent',
              bgcolor: selectedEmployee === 'all' ? 'primary.main' : 'grey.400',
              color: 'white',
              transition: 'all 0.15s ease',
              '&:hover': {
                transform: 'scale(1.1)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
              }
            }}
          >
            <PeopleIcon sx={{ fontSize: '1rem' }} />
          </Avatar>
        </Tooltip>

        {/* Employee avatars */}
        {employees.map((employee) => {
          const isSelected = selectedEmployee === employee.id;
          return (
            <Tooltip key={employee.id} title={employee.name} arrow>
              <Avatar
                onClick={() => handleEmployeeClick(employee.id)}
                sx={{
                  width: 32,
                  height: 32,
                  fontSize: '0.7rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  border: '2px solid',
                  borderColor: isSelected ? 'primary.main' : 'transparent',
                  bgcolor: isSelected ? 'primary.main' : 'grey.400',
                  color: 'white',
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    transform: 'scale(1.1)',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                  }
                }}
              >
                {employee.initials || '?'}
              </Avatar>
            </Tooltip>
          );
        })}
      </Stack>

      {/* Clear button - only show when filtered */}
      {selectedEmployee !== 'all' && (
        <IconButton
          size="small"
          onClick={() => onEmployeeChange('all')}
          sx={{ ml: 0.5 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Stack>
  );
};

export default EmployeeAvatarFilter;
